import { UserData } from "core/queries/GetUsers";
import { TypeEnum } from "typings/globalGQLTypes";

export interface TaskTypeOption {
  taskType: TypeEnum;
  displayName: string;
  alternateNames: string[];
  disabled?: boolean;
  allowedLinks: LinkEnum[];
}

export enum LinkEnum {
  dispatch = "dispatch",
  asana = "asana",
}

export const BatchedTasksType = "Tom_Tasks_BatchedTasksType";

export const TASK_TYPE_OPTIONS: TaskTypeOption[] = [
  {
    taskType: TypeEnum.GetFollowup,
    displayName: "GET action required",
    alternateNames: ["Internal Task - GET Action Required"],
    disabled: true,
    allowedLinks: [LinkEnum.dispatch],
  },
  {
    taskType: TypeEnum.Tom_Tasks_CreateLeaseCharge,
    displayName: "Create lease charge",
    alternateNames: [],
    disabled: true,
    allowedLinks: [LinkEnum.asana],
  },
  {
    taskType: TypeEnum.Tom_Tasks_CreateMasterLeaseRecord,
    displayName: "Create master lease record",
    alternateNames: [],
    disabled: true,
    allowedLinks: [LinkEnum.asana],
  },
  {
    taskType: TypeEnum.Tom_Tasks_DirtyCheckInWarning,
    displayName: "Dirty check-in warning",
    alternateNames: [],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_EarlyCheckIn,
    displayName: "Early check-in",
    alternateNames: ["Guest Request - Early check in"],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_EciLcoFollowup,
    displayName: "ECI/LCO follow-up",
    alternateNames: [],
    allowedLinks: [LinkEnum.asana],
  },
  {
    taskType: TypeEnum.Tom_Tasks_GetFollowup,
    displayName: "GET action required",
    alternateNames: ["Internal Task - GET Action Required"],
    disabled: true,
    allowedLinks: [LinkEnum.dispatch],
  },
  {
    taskType: TypeEnum.Tom_Tasks_TrustAndSafetyFollowup,
    displayName: "Trust And Safety action required",
    alternateNames: ["Internal Task - Trust and Safety Action Required"],
    allowedLinks: [LinkEnum.asana, LinkEnum.dispatch],
  },
  {
    taskType: TypeEnum.Tom_Tasks_TrustAndSafetyRequestToBanGuest,
    displayName: "Trust And Safety Request to Ban Guest",
    alternateNames: ["Internal Task - Trust and Safety Request to Ban Guest"],
    allowedLinks: [LinkEnum.asana, LinkEnum.dispatch],
  },
  {
    taskType: TypeEnum.Tom_Tasks_GuestInUnitAfterCheckout,
    displayName: "Guest in unit after check-out",
    alternateNames: ["Internal Task - Guest in unit after checkout"],
    allowedLinks: [LinkEnum.dispatch],
  },
  {
    taskType: TypeEnum.Tom_Tasks_GuestIssue,
    displayName: "Guest issue",
    alternateNames: [
      "Guest Issue - Access",
      "Guest Issue - Air conditioning",
      "Guest Issue - Broken appliance",
      "Guest Issue - Stained or damaged furniture / amenities",
      "Guest Issue - Bugs or rodents",
      "Guest Issue - Cable",
      "Guest Issue - Cleanliness",
      "Guest Issue - Electrical",
      "Guest Issue - Heat",
      "Guest Issue - Internet",
      "Guest Issue - Missing item or amenity",
      "Guest Issue - Noise complaint",
      "Guest Issue - Parking",
      "Guest Issue - Plumbing",
      "Guest Issue - Stained or damaged linens",
    ],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_GuestRequest,
    displayName: "Guest request",
    alternateNames: [
      "Guest Request - Amenities",
      "Guest Request - Fan",
      "Guest Request - Forgotten personal item",
      "Guest Request - Furniture",
      "Guest Request - Groceries",
      "Guest Request - Heater",
      "Guest Request - High chair",
      "Guest Request - Intrastay cleaning",
      "Guest Request - Noise machine",
      "Guest Request - Pack and play",
      "Guest Request - Package/mail",
      "Guest Request - Sheets",
      "Guest Request - Special Occasion",
    ],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_HoldSecurityDeposit,
    displayName: "Hold security deposit",
    alternateNames: ["Internal Task - Hold Security Deposit"],
    allowedLinks: [LinkEnum.asana, LinkEnum.dispatch],
  },
  {
    taskType: TypeEnum.Tom_Tasks_InPersonCheckIn,
    displayName: "In person check-in",
    alternateNames: [],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_InspectionTask,
    displayName: "(LEGACY) Inspection",
    alternateNames: [],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_InternalHoldChecklist,
    displayName: "Internal hold checklist",
    alternateNames: [],
    allowedLinks: [LinkEnum.dispatch],
  },
  {
    taskType: TypeEnum.Tom_Tasks_InternalInquiryTask,
    displayName: "Internal inquiry task",
    alternateNames: [
      "Internal Task - Inquiry",
      "Internal Task - Check in action required",
      "Internal Task - Deliver item to guest",
      "Internal Task - In person check in",
      "Internal Task - Item left behind by guest",
    ],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_InternalSubtask,
    displayName: "Internal sub-task",
    alternateNames: [],
    disabled: true,
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_InternalUnitTask,
    displayName: "Internal unit task",
    alternateNames: [
      "Internal tast - Unit",
      "Internal Task - Access",
      "Internal Task - Air conditioning",
      "Internal Task - Broken appliance",
      "Internal Task - Stained or damaged furniture / amenities",
      "Internal Task - Bugs or rodents",
      "Internal Task - Cable",
      "Internal Task - Cleanliness",
      "Internal Task - Electrical",
      "Internal Task - Garbage Collection",
      "Internal Task - Heat",
      "Internal Task - Internet",
      "Internal Task - Missing item or amenity",
      "Internal Task - Other Maintenance",
      "Internal Task - Plumbing",
      "Internal Task - Showing or open house",
      "Internal Task - Stained or damaged linens",
      "Internal Task - Update CUF",
    ],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_LateCheckOut,
    displayName: "Late check out",
    alternateNames: ["Guest Request - Late check out"],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_LeaseBillingSchedule,
    displayName: "Lease billing schedule",
    alternateNames: [],
    disabled: true,
    allowedLinks: [LinkEnum.asana],
  },
  {
    taskType: TypeEnum.Tom_Tasks_LongTermCheckIn,
    displayName: "Long-term check-in",
    alternateNames: [],
    allowedLinks: [LinkEnum.asana],
  },
  {
    taskType: TypeEnum.Tom_Tasks_LongTermCheckOut,
    displayName: "Long-term check-out",
    alternateNames: [],
    allowedLinks: [LinkEnum.asana],
  },
  {
    taskType: TypeEnum.Tom_Tasks_LongTermNycCheckInSubTask,
    displayName: "Long-term NYC check-in sub-task",
    alternateNames: [],
    disabled: true,
    allowedLinks: [LinkEnum.asana],
  },
  {
    taskType: TypeEnum.Tom_Tasks_LongTermNycCheckOutSubTask,
    displayName: "Long-term NYC check-out sub-task",
    alternateNames: [],
    disabled: true,
    allowedLinks: [LinkEnum.asana],
  },
  {
    taskType: TypeEnum.Tom_Tasks_LongTermStay,
    displayName: "Long term stay request",
    alternateNames: ["Guest Request - Long Term Stay"],
    allowedLinks: [LinkEnum.asana],
  },
  {
    taskType: TypeEnum.Tom_Tasks_LongTermSubTask,
    displayName: "Long term stay sub-task",
    alternateNames: ["Guest Request - Long Term Stay"],
    disabled: true,
    allowedLinks: [LinkEnum.asana],
  },
  {
    taskType: TypeEnum.Tom_Tasks_LuggageDropOff,
    displayName: "Luggage drop-off",
    alternateNames: ["Guest Request - Luggage storage"],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_MaintenanceInspectionTask,
    displayName: "Maintenance QA",
    alternateNames: [
      "Maintenance inspection",
      "Internal Task - Maintenance QA",
    ],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_MoveInCompletionQualityAudit,
    displayName: "Move-In Completion QA",
    alternateNames: ["Internal Task - Move-In Completion QA"],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_OnboardingInspectionTask,
    displayName: "On-boarding inspection task",
    alternateNames: ["Internal Task - Guest Ready QA"],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_OrderGroceriesTask,
    displayName: "Order groceries task",
    alternateNames: ["Guest Request - Groceries"],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_Other,
    displayName: "Other",
    alternateNames: [],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_PickupTask,
    displayName: "Pick-up task",
    alternateNames: [],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_QualityAudit,
    displayName: "QA",
    alternateNames: ["Inspection", "Quality audit"],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_QuantityGuestRequest,
    displayName: "Quantity guest request",
    alternateNames: [
      "Guest Request - Quantity",
      "Guest Request - Blankets",
      "Guest Request - Coffee",
      "Guest Request - Keys",
      "Guest Request - Noise machine",
      "Guest Request - Pack and play",
      "Guest Request - Pillows",
      "Guest Request - Sheets",
      "Guest Request - Towels",
    ],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_RefundSecurityDeposit,
    displayName: "Refund security deposit",
    alternateNames: [],
    allowedLinks: [LinkEnum.asana],
  },
  {
    taskType: TypeEnum.Tom_Tasks_SpaceClean,
    displayName: "Space cleans",
    alternateNames: [],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_VipBookingNotification,
    displayName: "VIP booking notification",
    alternateNames: [],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_TrustAndSafetyEjection,
    displayName: "Trust and Safety Ejection",
    alternateNames: [],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_Clean,
    displayName: "Clean",
    alternateNames: ["Clean Task"],
    disabled: true,
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_IntrastayCheck,
    displayName: "Intrastay Check",
    alternateNames: ["Intrastay Check Task"],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_Issue,
    displayName: "Issue",
    alternateNames: [],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_Booking,
    displayName: "Booking",
    alternateNames: [],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_TrustAndSafety,
    displayName: "Trust And Safety",
    alternateNames: [],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_Request,
    displayName: "Request",
    alternateNames: [],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_Inspection,
    displayName: "Inspection",
    alternateNames: [],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_Booking,
    displayName: "Booking",
    alternateNames: [],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_GetRelocation,
    displayName: "GET Relocation",
    alternateNames: [],
    allowedLinks: [],
  },
  {
    taskType: TypeEnum.Tom_Tasks_Clean,
    displayName: "Clean",
    alternateNames: [],
    allowedLinks: [],
  },
];

export const ENABLED_TASK_TYPE_OPTIONS = TASK_TYPE_OPTIONS.filter(
  option => option.disabled !== true,
);

export const GET_USER = {
  __typename: "User" as UserData["__typename"],
  avatar: null,
  cleaningCompanies: null,
  dispatchRoles: [],
  email: "reservations@flatbook.co",
  firstName: "GET",
  id: GET_USER_ID,
  lastName: "User",
  name: "GET User",
  roles: [],
  tags: [],
  tomTeamMember: null,
};

export const TNS_USER = {
  __typename: "User" as UserData["__typename"],
  avatar: null,
  cleaningCompanies: null,
  dispatchRoles: [],
  email: "tns@sonder.com",
  firstName: "Trust",
  id: TNS_USER_ID,
  lastName: "and Safety",
  name: "Trust and Safety",
  roles: [],
  tags: [],
  tomTeamMember: null,
};

export const TASK_CONTEXT_CUSTOM_UNIQUE_REFS = {
  CGS_ACTION_REQUIRED:
    "Tom::Tasks::Booking|CGS Action Required|CGS|Unit|No Location",
};
